import i18n from "@/i18n";
import { Route } from "vue-router";

export function setMetaTitleOfLandingView(to: Route) {
  if (to.name === "mapType-landing-view") {
    if (to.params.mapType) {
      if (!to.meta) return;
      const key = `TOP.${to.params.mapType}`;
      to.meta.title = `${i18n.t(key)} Map view | VACAN Maps-バカン-`;
    }
  }
}

export function replaceTitleTab(to: Route) {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
}

export function setHtmlLang(locale: string) {
  const documentRoot = document.getElementsByTagName("html")[0];
  if (documentRoot) {
    documentRoot.lang = locale;
  }
}
